// frontend/src/utils/plan-capabilities.ts
// Single source of truth for plan-based capabilities and project limits.
// Keep this file declarative; do not import React here.

export type Plan = "free" | "pro" | "enterprise";

export const FREE_MAX_PROJECTS = 100 as const;

export type FeatureKey =
  | "project.create"
  | "project.duplicate"
  | "project.addSample"
  // future flags (UI gating only; mirror on backend later)
  | "results.downloadPdf"
  | "scenario.analysis";

type CapabilityMatrix = Record<Plan, Partial<Record<FeatureKey, boolean>>>;

export const capabilities: CapabilityMatrix = {
  free: {
    "project.create": true,       // allowed, but capped by count
    "project.duplicate": true,    // allowed, but capped by count
    "project.addSample": true,    // allowed, but capped by count
    "results.downloadPdf": false, // gated for free
    "scenario.analysis": false,   // gated for free
  },
  pro: {
    "project.create": true,
    "project.duplicate": true,
    "project.addSample": true,
    "results.downloadPdf": true,
    "scenario.analysis": true,
  },
  enterprise: {
    "project.create": true,
    "project.duplicate": true,
    "project.addSample": true,
    "results.downloadPdf": true,
    "scenario.analysis": true,
  },
};

export function canUse(plan: Plan | undefined, feature: FeatureKey): boolean {
  if (!plan) return false;
  return !!capabilities[plan]?.[feature];
}